export default (props, vars) =>
  !!vars?.useapplicationoffer2?.applicationOffer?.start_date;
